import Empty from "./emptyType1";

export { Empty };
export default Empty;
